<div class="layout-conatiner text" [ngStyle]="style" *ngIf="operation">
    <div class="detail-container">
        <div>
            <div class="detail-title">
                <div>User</div>
            </div>
            <div class="detail-content">
                <div>
                    {{
                        userNamePrefix.concat(".", operation.user.userRole.role)
                            | translate
                            | uppercase
                    }}
                </div>
            </div>
        </div>
        <div>
            <div class="detail-title">
                <div>Ch. no</div>
            </div>
            <div class="detail-content">
                <div>{{ operation.id }}</div>
            </div>
        </div>
        <div>
            <div class="detail-title">
                <div>Status</div>
            </div>
            <div class="detail-content">
                <div>{{ operation.status }}</div>
            </div>
        </div>
        <div>
            <div class="detail-title">
                <div>Action</div>
            </div>
            <div class="detail-content action">
                <div>
                    {{ operation.before }}
                    <span class="arrow">&#8594;</span>
                    {{ operation.after }}
                </div>
            </div>
        </div>

        <div>
            <div class="detail-title">
                <div>Date/Time</div>
            </div>
            <div class="detail-content">
                <div>{{ operation.datetime }}</div>
            </div>
        </div>

        <div>
            <button (click)="setVisible(false)">CLOSE</button>
        </div>
    </div>
</div>
